
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { MyCoachMixin, CoachReportScoreMixin, StringsMixin } from "@/mixins";
import { ScoutingReportModel } from '@/models/scoutingReport/ScoutingReportModel';
import ScoreSelector from '@/components/forms/ScoreSelector.vue';

@Component({
	components: {
		ScoreSelector,
	},
})

export default class ScoutingReportMatrixV3 extends Mixins(MyCoachMixin, CoachReportScoreMixin, StringsMixin){
	@Prop() report: ScoutingReportModel | null;

    mounted() {
        this.onLoadReport();
    }

    isReportCommentsAvailable: boolean = false;
    @Watch('report')
    onLoadReport(): void {
        this.isReportCommentsAvailable = this.checkForComments();
    }

    checkForComments(): boolean {
        if( this.IsEmpty(this.report) ) return false;
        for( const category of this.report.evaluation.athleteAttributes ) if( this.IsNotEmpty(category.notes) ) return true;
        for( const category of this.report.evaluation.gameMoments ) if( this.IsNotEmpty(category.notes) ) return true;
        for( const category of this.report.evaluation.scoutingEval ) if( this.IsNotEmpty(category.notes) ) return true;
        return false;
    }
}
